<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3.250234375,10.259999949932098C3.250234375,10.259999949932098,5.720234375,12.729999949932099,5.720234375,12.729999949932099C5.720234375,12.729999949932099,12.410234375,6.039999949932098,12.410234375,6.039999949932098C12.410234375,6.039999949932098,9.950234375,3.5599999499320982,9.950234375,3.5599999499320982C9.950234375,3.5599999499320982,3.250234375,10.259999949932098,3.250234375,10.259999949932098C3.250234375,10.259999949932098,3.250234375,10.259999949932098,3.250234375,10.259999949932098ZM0.990234375,14.989999949932098C0.990234375,14.989999949932098,4.850234374999999,13.599999949932098,4.850234374999999,13.599999949932098C4.850234374999999,13.599999949932098,2.390234375,11.159999949932098,2.390234375,11.159999949932098C2.390234375,11.159999949932098,0.990234375,14.989999949932098,0.990234375,14.989999949932098C0.990234375,14.989999949932098,0.990234375,14.989999949932098,0.990234375,14.989999949932098ZM13.240234375,0.9899999499320984C12.760234375,0.9899999499320984,12.320234375,1.1899999499320983,12.000234375,1.4999999499320984C12.000234375,1.4999999499320984,10.560234375,2.9399999499320986,10.560234375,2.9399999499320986C10.560234375,2.9399999499320986,13.030234375,5.409999949932098,13.030234375,5.409999949932098C13.030234375,5.409999949932098,14.470234375,3.9699999499320984,14.470234375,3.9699999499320984C14.790234375,3.6499999499320985,14.980234375,3.2199999499320984,14.980234375,2.7299999499320986C14.990234375,1.7799999499320984,14.210234375,0.9899999499320984,13.240234375,0.9899999499320984C13.240234375,0.9899999499320984,13.240234375,0.9899999499320984,13.240234375,0.9899999499320984Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Edit',
} as DefineComponent
</script>
